// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__18AMB","row":"Node_row__3XVbx","label":"Node_label__1AB19","footer":"Node_footer__3CFU_"};